<div class="spinner" *ngIf="active">
  <img
    alt="Loading Spinner"
    class="spinner-image"
    [src]="'assets/images/spinner.png'"
  />
</div>
